module.exports = __webpack_public_path__ + "img/recharge.f778b8dd.png";